import classNames from 'classnames';
import React from 'react';

export interface UDProgressBarProps {
  /** Done share, 0–1. Out-of-range values are clamped. */
  value: number;
  /** Accessible name — what is in progress («Сборка видео»). The bar has no visible label of its own. */
  label: string;
  /** Read instead of the percent when the percent alone misleads («Клип 3 из 9»). */
  valueText?: string;
  className?: string;
}

/**
 * Determinate progress of a long operation: a thin yellow bar on a sunken track. Only for a known share — while the
 * share is unknown, show text, not an empty bar. Percent text, «Отменить» and the rest are the caller's.
 *
 * `role="progressbar"` with `aria-valuenow` in percent (WAI-ARIA, MDN «progressbar role»); the width animates
 * 200 ms, never with reduced motion.
 */
const UDProgressBar = ({ value, label, valueText, className }: UDProgressBarProps) => {
  const share = Number.isFinite(value) ? Math.min(Math.max(value, 0), 1) : 0;
  const percent = Math.round(share * 100);

  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={percent}
      aria-valuetext={valueText}
      className={classNames('bg-surfaceSunken rounded-pill h-1.5 w-full overflow-hidden', className)}
    >
      <div
        className="bg-accentNaplesYellow rounded-pill h-full transition-[width] duration-200 ease-out motion-reduce:transition-none"
        style={{ width: `${share * 100}%` }}
        data-testid="progress-bar-fill"
      />
    </div>
  );
};

export default UDProgressBar;
